export default __webpack_public_path__ + "static/media/580.a3f9e803.png";